import React from "react";
import { Box, Typography } from "@mui/material";
import ToggleRow from "../../../common/ToggleRow";
import AgentConfigSection from "../AgentConfigSection";
import PlanTemplateEditor from "../../ManagedRunPolicy/PlanTemplateEditor";
import { NODE_UI } from "../../../NodeUI";
import { defaultSelfDrivingDraft, emptyStep } from "../selfDrivingModel";

export default function SelfDrivingTab({
  selfDriving,
  setSelfDriving,
  setSelfDrivingField,
}) {
  const slice = selfDriving || { enabled: false, goal: "", tasks: [] };
  const steps = slice.tasks || [];

  const handleToggle = (checked) => {
    if (checked && steps.length === 0) {
      setSelfDriving(defaultSelfDrivingDraft());
      return;
    }
    setSelfDrivingField("enabled", checked);
  };

  const handleStepChange = (index, nextStep) =>
    setSelfDriving((prev) => {
      const tasks = [...(prev.tasks || [])];
      tasks[index] = nextStep;
      return { ...prev, tasks };
    });

  const handleStepRemove = (index) =>
    setSelfDriving((prev) => {
      const tasks = [...(prev.tasks || [])];
      tasks.splice(index, 1);
      return { ...prev, tasks };
    });

  const handleAddStep = () =>
    setSelfDriving((prev) => ({
      ...prev,
      tasks: [...(prev.tasks || []), emptyStep()],
    }));

  return (
    <AgentConfigSection id="self-driving">
      <ToggleRow
        checked={!!slice.enabled}
        onChange={handleToggle}
        title="Self-driving"
        description="When on, every new chat starts with this plan. The agent works through the steps on its own and comes back at the times you set — no need to keep prompting it."
      />

      {slice.enabled ? (
        <Box sx={{ mt: 2 }}>
          <Typography
            sx={{
              fontSize: NODE_UI.fontSize.caption,
              color: "text.secondary",
              lineHeight: 1.4,
              mb: 1.5,
            }}
          >
            Turn on Plan tasks, Update task queue, and Schedule message on the
            Tools tab so the agent can follow the plan and wait between steps.
          </Typography>

          <PlanTemplateEditor
            goal={slice.goal || ""}
            tasks={steps}
            onGoalChange={(next) => setSelfDrivingField("goal", next)}
            onStepChange={handleStepChange}
            onStepRemove={handleStepRemove}
            onAddStep={handleAddStep}
            goalHelperText="What this agent should keep working toward in every chat."
          />
        </Box>
      ) : null}
    </AgentConfigSection>
  );
}
